import React, { forwardRef, useEffect, useImperativeHandle } from 'react';

import * as General from '../General/General.js';
import * as rsuite from 'rsuite';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import PN from 'persian-number'
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import AddBasketItem from "../Basket/AddBasketItem.js";
import { BasketContext } from "../Context/BasketContext.js";

const BasketShow = forwardRef((props, ref) => {
    const toaster = rsuite.useToaster();

    // const [BasketItemList, setBasketItemList] = React.useContext(BasketContext);
    // const { setCount } = React.useContext(BasketContext); // 👈 اینجاست
    // const [TotalPrice, setTotalPrice] = React.useContext(BasketContext)

    const {
        BasketItemList,
        setBasketItemList,
        TotalPrice,
        setTotalPrice,
        count,
        setCount,
        basketRef
    } = React.useContext(BasketContext);



    const [Open, setOpen] = React.useState(false);

    const Bind = () => {
        var RequestOptions = {
            data: {
            },
            url: General.ApiRoute() + "/Basket/Basket_GetByCustomerId",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json',
                "CustomerId": localStorage.getItem("CustomerFarmAsanId")

            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var tmp = [];
                    var itemCount = 0;
                    setTotalPrice(result.data.totalPrice);
                    for (var i = 0; i < result.data.children.length; i++) {
                        itemCount = itemCount + result.data.children[i].count
                        tmp.push({
                            row: i + 1,
                            Id: result.data.children[i].id,
                            ProductId: result.data.children[i].productId,
                            StoreRoomInventoryId: result.data.children[i].storeRoomInventoryId,
                            Product: result.data.children[i].product,
                            Title: result.data.children[i].title,
                            Group: result.data.children[i].group,
                            Parent: result.data.children[i].parent,
                            Count: result.data.children[i].count,
                            Unit: result.data.children[i].unit,
                            TotalPrice: result.data.children[i].totalPrice,
                            Price: result.data.children[i].price,
                            Tax: result.data.children[i].tax,
                            SaleType: result.data.children[i].saleType,
                            DiscountPrice: result.data.children[i].discountPrice,
                            DiscountPercent: result.data.children[i].discountPercent,
                            PhotoUrl: result.data.children[i].photos.length > 0 ? General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + result.data.children[i].photos[0].photoURLName : '',
                        })
                    }

                    setBasketItemList([...tmp]);
                    setCount(itemCount)



                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )

    }

    const ShowProduct = (id, title, Parent, Group) => {
        localStorage.setItem("ProductId", id);
        localStorage.setItem("ByBrand", false);
        localStorage.setItem("BySuggestion", false);
        localStorage.setItem("ByCompare", false);

        var parent = General.toSlug(Parent, { latin: true })
        var group = General.toSlug(Group, { latin: true })
        var product = General.toSlug(title, { latin: true })

        var NewGroup = group != parent ? group.replace(parent, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") : group;
        var Newproduct = product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") == "" ? product :
            product.replace(parent, "").replace(NewGroup, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "");
        window.location.href = '/ProductInfo/' + parent + "/" + NewGroup + "/" + Newproduct;


    }

    const GoToBasket = () => {
        window.location.href = '/Basket'
    }

    useImperativeHandle(ref, () => ({

        GetCount: () => {
            const RequestOptions = {
                url: General.ApiRoute() + "/Basket/BasketItem_GetCountByCustomerId",
                method: "post",
                withCredentials: true,
                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json',
                    "CustomerId": localStorage.getItem("CustomerFarmAsanId")
                }
            }

            return axios(RequestOptions)
                .then(res => setCount(res.data))
                .catch(err => {
                    console.error(err);
                    return -1;
                });
        },
        Bind: () => {
            Bind()


        },
        Show: () => {
            setOpen(true);
            Bind();
        }

    }))

    useEffect(() => {
        console.log("BasketShow mounted");
    }, []);



    return (
        <rsuite.Drawer size={isMobile ? "full" : "md"} placement="left" open={Open} onClose={() => (setOpen(false), setBasketItemList([]))}>
            <rsuite.Drawer.Header>
                <rsuite.Drawer.Title className=" Font13">
                    {localStorage.getItem("UserFullNameFarmAsan") == null ? "" : localStorage.getItem("UserFullNameFarmAsan")}

                </rsuite.Drawer.Title>
                <rsuite.Drawer.Actions>
                    <img className="Cursor" src="../../../../../../assets/images/Logo.png" style={{ width: 30, height: 30, marginTop: 8 }} />
                </rsuite.Drawer.Actions>
            </rsuite.Drawer.Header>
            <rsuite.Drawer.Body className="text-center">

                {BasketItemList.map(item => (
                    <rsuite.Col xs={24} className=" border rounded-2 border-2 mb-2">

                        <rsuite.Panel bodyFill >
                            <rsuite.Row>
                                <rsuite.Col xs={7} className="m-0 p-0">
                                    <rsuite.Image
                                        src={item.PhotoUrl}
                                        fallbackSrc="../../../../assets/images/ProductGroupPrefer.jpg"
                                        style={{ width: '150px', height: '170px' }}
                                        className="border-radius-half Cursor text-end"
                                    />
                                </rsuite.Col>
                                <rsuite.Col xs={17} className="m-0 p-0" >

                                    <rsuite.Card.Body >
                                        <rsuite.Row className='mt-2'>
                                            <rsuite.Col xs={24} className=' text-end'>
                                                <button type="button" onClick={() => ShowProduct(item.ProductId, item.Product, item.Parent, item.Group)} class="btn btn-link FarmAsan-text">
                                                    <b> {item.Title} (مشاهده محصول ...) </b>
                                                </button>

                                            </rsuite.Col>
                                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                                <b> تعداد: </b> {item.Count} {item.Unit}
                                            </rsuite.Col>
                                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                                <b>  قیمت واحد : </b> {PN.sliceNumber(item.Price)} ریال
                                            </rsuite.Col>
                                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                                <b>  مالیات  : </b> {PN.sliceNumber(item.Tax)} ریال
                                            </rsuite.Col>
                                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                                <b>  تخفیف  : </b> {PN.sliceNumber(item.DiscountPrice)} ریال
                                            </rsuite.Col>
                                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='p-2 text-end'>
                                                <b>  قیمت کل : </b> {PN.sliceNumber(item.TotalPrice)} ریال
                                            </rsuite.Col>
                                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={item.SaleType == 2 ? 'p-2 text-end' : "hide"}>
                                                <span className="text-success text-decoration-underline fw-bold">رزرو شده است</span>

                                            </rsuite.Col>
                                            <rsuite.Col xs={24} className='ms-4 ps-4 text-start mb-2 ' >
                                                <AddBasketItem className="Group" value={item.ProductId + "|" + item.Title + "|1|" + item.StoreRoomInventoryId + "|" + item.Price + "|" + item.SaleType + "|" + item.Count + "|" + item.Id} />
                                            </rsuite.Col>


                                        </rsuite.Row>
                                    </rsuite.Card.Body>

                                </rsuite.Col>
                            </rsuite.Row>

                        </rsuite.Panel>
                    </rsuite.Col>

                ))}
                {BasketItemList.length > 0 ?
                    <rsuite.Col xs={24} className=" border rounded-2 border-2 mb-2">
                        <rsuite.Row>
                            <rsuite.Card.Body >
                                <rsuite.Row className='mt-2 Font14'>

                                    <rsuite.Col xs={24} className='p-2 text-end'>
                                        <b> تعداد اقلام فاکتور : </b> {BasketItemList.map(o => o.Count).reduce((a, b) => a + b)}
                                    </rsuite.Col>
                                    <rsuite.Col xs={24} className={BasketItemList.map(o => o.DiscountPrice).reduce((a, b) => a + b) > 0 ? 'p-2 text-end' : 'hide'}>
                                        <b>  قیمت قبل از تخفیف : </b>
                                        {PN.sliceNumber(BasketItemList.map(o => (o.Tax + o.Price) * o.Count).reduce((a, b) => a + b))}
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{PN.convert(BasketItemList.map(o => (o.Tax + o.Price) * o.Count).reduce((a, b) => a + b).toString().replaceAll(',', ''))}&nbsp;&nbsp;&nbsp;
                                        ریال
                                    </rsuite.Col>
                                    <rsuite.Col xs={24} className={BasketItemList.map(o => o.Tax).reduce((a, b) => a + b) > 0 ? 'p-2 text-end' : 'hide'}>
                                        <b>  مالیات  : </b>  {PN.sliceNumber(BasketItemList.map(o => o.Tax * o.Count).reduce((a, b) => a + b))}
                                        &nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;{PN.convert(BasketItemList.map(o => o.Tax * o.Count).reduce((a, b) => a + b).toString().replaceAll(',', ''))}
                                        &nbsp;&nbsp;&nbsp;
                                        ریال
                                    </rsuite.Col>
                                    <rsuite.Col xs={24} className={BasketItemList.map(o => o.DiscountPrice).reduce((a, b) => a + b) > 0 ? 'p-2 text-end' : 'hide'}>
                                        <b>  تخفیف  : </b>  {PN.sliceNumber(BasketItemList.map(o => o.DiscountPrice * o.count).reduce((a, b) => a + b))}
                                        &nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;{PN.convert(BasketItemList.map(o => o.DiscountPrice * o.Count).reduce((a, b) => a + b).toString().replaceAll(',', ''))}
                                        &nbsp;&nbsp;&nbsp;
                                        ریال
                                    </rsuite.Col>
                                    <rsuite.Col xs={24} className='p-2 text-end'>
                                        <b>  مبلغ قابل پرداخت : </b>  {PN.sliceNumber(BasketItemList.map(o => o.TotalPrice).reduce((a, b) => a + b))}
                                        &nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;{PN.convert(BasketItemList.map(o => o.TotalPrice).reduce((a, b) => a + b).toString().replaceAll(',', ''))}
                                        &nbsp;&nbsp;&nbsp;
                                        ریال
                                    </rsuite.Col>



                                </rsuite.Row>
                            </rsuite.Card.Body>



                        </rsuite.Row>
                    </rsuite.Col>
                    :
                    <></>
                }
                <rsuite.Col xs={24} >
                    <rsuite.Button className='FarmAsan-success'
                        onClick={() => GoToBasket()}
                        appearance="primary" block>  ادامه خرید و پرداخت</rsuite.Button>
                </rsuite.Col>
            </rsuite.Drawer.Body>



        </rsuite.Drawer >

    )
});

export default BasketShow;